<template>
  <v-container fluid>
    <v-layout align-center justify-center column fill-height>
      <v-flex xs12>
        <v-progress-circular
          :rotate="360"
          :size="100"
          :width="15"
          :indeterminate="true"
          color="primary"
        ></v-progress-circular>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'OidcCallback',
  methods: {
    ...mapActions([
      'oidcSignInCallback'
    ])
  },
  mounted () {
    var self = this;
    self.oidcSignInCallback()
      .then((redirectPath) => {
        self.$router.push(redirectPath)
      })
      .catch((err) => {
        console.error(err)
        self.$router.push('/oidc-callback-error') // Handle errors any way you want
      })
  }
}
</script>